<template>
    <div></div>
</template>

<script>
export default {
    name: "PrometDetails"
}
</script>

<style scoped>

</style>